import React from 'react';
import { QuoteInvoicingShowDataForm } from '../../../../app/models/QuoteInvoicing';
import { ExchangeRateDateEnum }    from '../../../../app/shared/enums';

interface Props {
  quoteInvoicingForm: QuoteInvoicingShowDataForm;
}

const QuoteInvoicingShowForm: React.FC<Props> = ({ quoteInvoicingForm }) => {
  // Derivamos directamente si es fecha fija, leyendo el .id del objeto value:
  const showPrelimFixed =
    quoteInvoicingForm.preliminary_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  const showFinalFixed =
    quoteInvoicingForm.final_exchange_rate_date_reference?.id ===
    ExchangeRateDateEnum.FECHA_FIJA;

  return (
    <div className="container-fluid">
      {/* 1. Forma de pago y referencia */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label>Forma de Pago</label>
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.payment_method || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>Condición de Pago</label>
          <div className="row g-1">
            <div className="col-8">
              <input
                type="text"
                className="form-control bg-light"
                value={quoteInvoicingForm.reference || ''}
                readOnly
                placeholder="Referencia"
              />
            </div>
            <div className="col-4">
              <input
                type="number"
                className="form-control bg-light"
                value={quoteInvoicingForm.days_count ?? ''}
                readOnly
                placeholder="Días"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <label>Cantidad máxima de pagos</label>
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.max_payments_value || ''}
            readOnly
          />
        </div>
      </div>

      {/* 2. Moneda y fuente tipo cambio */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label>Moneda</label>
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.currency || ''}
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label>Fuente Tipo de Cambio</label>
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.exchange_rate_date_source || ''}
            readOnly
          />
        </div>
      </div>

      {/* 3. Tipo de cambio preliminar y final */}
      <div className="row">
        {/* — Preliminar — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Prov</label>
          {/* Muestro el nombre (label) */}
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.preliminary_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {showPrelimFixed ? (
            <>
              <label className="form-label mt-2">Fecha Fija (Prov)</label>
              <input
                type="date"
                className="form-control bg-light"
                value={quoteInvoicingForm.preliminary_fixed_date || ''}
                readOnly
              />
            </>
          ) : (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.preliminary_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.preliminary_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Prov)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.preliminary_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}
        </div>

        {/* — Final — */}
        <div className="col-lg-6 mb-3">
          <label>Tipo de Cambio Final</label>
          <input
            type="text"
            className="form-control bg-light"
            value={quoteInvoicingForm.final_exchange_rate_date_reference_value || ''}
            readOnly
          />

          {showFinalFixed ? (
            <>
              <label className="form-label mt-2">Fecha Fija (Final)</label>
              <input
                type="date"
                className="form-control bg-light"
                value={quoteInvoicingForm.final_fixed_date || ''}
                readOnly
              />
            </>
          ) : (
            <div className="row g-2 mt-2">
              <div className="col-3">
                <label className="form-label">Días (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.final_days ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Meses (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.final_months ?? ''}
                  readOnly
                />
              </div>
              <div className="col-3">
                <label className="form-label">Año (Final)</label>
                <input
                  type="number"
                  className="form-control bg-light"
                  value={quoteInvoicingForm.final_year ?? ''}
                  readOnly
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuoteInvoicingShowForm;
